import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactApexChart from 'react-apexcharts'

import { GET, httpOk } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

import { formatPeriod } from './utils'

const MONTHS = [12, 24, 36]

// Прогноз амортизации по месяцам — для бюджета: сколько расходов «без денег» ляжет в P&L.
// Падение графика — момент, когда имущество полностью самортизировалось и пора закладывать замену.
// Точка не выбирается: прогноз по торговой точке из шапки кабинета
function Forecast({ posId }) {
	const { t } = useTranslation()

	const [months, setMonths] = useState(12)
	const [data, setData] = useState([])

	async function getData(currentPosId = posId, currentMonths = months) {
		var url = '/finance/fixed-assets/forecast?months=' + currentMonths
		if (currentPosId) url += '&pos_id=' + currentPosId
		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const total = data.reduce((sum, row) => sum + Number(row.amount), 0)

	return (
		<div className="card">
			<div className="card-body">
				<div className="row g-2 mb-3">
					<div className="col-md-2">
						<select className="form-select" value={months}
							onChange={(e) => { const value = Number(e.target.value); setMonths(value); getData(posId, value) }}>
							{MONTHS.map(value => (
								<option key={value} value={value}>{value} {t('fa_months_short')}</option>
							))}
						</select>
					</div>
					<div className="col-md-10 text-muted vertical-center">{t('fa_forecast_hint')}</div>
				</div>

				{/* Без начислений apexcharts рисует ось «Infinity» — вместо пустого графика пишем, почему пусто */}
				{total > 0
					? <ReactApexChart
						type="bar"
						height={280}
						series={[{ 'name': t('fa_monthly'), 'data': data.map(row => Number(row.amount)) }]}
						options={{
							'chart': { 'toolbar': { 'show': false } },
							'dataLabels': { 'enabled': false },
							'xaxis': { 'categories': data.map(row => formatPeriod(row.period)) },
							'yaxis': { 'min': 0, 'labels': { 'formatter': (value) => formatMoney(value) } },
							'tooltip': { 'y': { 'formatter': (value) => formatMoney(value) } },
						}}
					/>
					: <div className="text-center text-muted py-5">{t('fa_forecast_empty')}</div>
				}

				<div className="table-responsive mt-3">
					<table className="table table-bordered table-sm mb-0">
						<thead>
							<tr>
								<th>{t('fa_period')}</th>
								<th className="text-end">{t('fa_monthly')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map(row => (
								<tr key={row.period}>
									<td>{formatPeriod(row.period)}</td>
									<td className="text-end">{formatMoney(row.amount)}</td>
								</tr>
							))}
							<tr className="fw-bold">
								<td>{t('total')}</td>
								<td className="text-end">{formatMoney(total)}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

export default Forecast
